module.exports = {
  siteTitle: 'Moti Smart Motors and Apps', // <title>
  manifestName: 'RobotStack',
  manifestShortName: 'RobotStack', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#222426',
  manifestThemeColor: '#222426',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  // pathPrefix: `/gatsby-starter-newage/`, // This path is subpath of your hosting https://domain/portfolio
  // social
  // socialLinks: [
  //   {
  //     icon: 'fa-github',
  //     name: 'Github',
  //     url: 'https://github.com/anubhavsrivastava',
  //   },
  //   {
  //     icon: 'fa-linkedin-in',
  //     name: 'Linkedin',
  //     url: 'https://linkedin.com/in/theanubhav/',
  //   },
  //   {
  //     icon: 'fa-twitter',
  //     name: 'Twitter',
  //     url: 'https://twitter.com/onlyanubhav',
  //   },
  //   {
  //     icon: 'fa-facebook-f',
  //     name: 'Facebook',
  //     url: 'https://facebook.com/theanubhav',
  //   },
  // ],
};
